export default {
      id: "icon-tooltip-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-tooltip",
      toString: function () {
        return this.url;
      }
    }